module.exports = __webpack_public_path__ + "img/paci_ar_8.df93ca36.png";